import HistoryButton from '../HistoryButton/HistoryButton';
import HeaderLogo from '../HeaderLogo/HeaderLogo';
import PrizeText from '../PrizeText/PrizeText';
import './Header.scss';

interface HeaderProps {
  showPrize: boolean;
}

const Header = ({ showPrize }: HeaderProps) => {
  return (
    <div className='header'>
      <div className='header-top-row'>
        <div className={'header-top-row__container'}>
          <div className='header-top-row__logo'>
            <HeaderLogo />
          </div>
        </div>
        <div className='header-top-row__history-button'>
          <HistoryButton />
        </div>
      </div>
      {showPrize && (
        <div className='header-bottom-row'>
          <div className='header-bottom-row__prize-text'>
            <PrizeText />
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
